import React from 'react'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'

export const chapters = [
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/rohstoffe.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 1',
      title: 'Rohstoffhandel',
      lead: 'Warum die Schweiz zur Drehscheibe für Öl und Gas wurde'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/rohstoffe.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Am Anfang war die List eines jungen Amerikaners. Der Rohstoffhändler
            Marc Rich gründete 1974 in Zug eine Rohstofffirma, die spätere
            Glencore. Sein Credo: Handeln mit allem und jedem, sogar mit
            Rassisten und Ayatollahs. Er brach das Monopol der grossen
            Erdölkonzerne und brachte die Schweiz in den 70er-Jahren auf die
            Karte der Rohstoffhändler.
          </p>
          <p>
            Als Handelsplatz anerbot sich damals das nahe Genf. Eine
            mehrsprachige Stadt, mit tiefen Steuern, schwacher Regulierung und
            vielen Banken, dazu neutral und mitten im Kalten Krieg ohne grössere
            Probleme bereisbar. Trader und Firmen zogen hin. Genf verwandelte
            sich zur Drehscheibe des weltweiten Ölhandels.
          </p>
          <p>
            Als die Sowjetunion zerfiel, ging es erst richtig los. Die
            Rohstoffhändler knüpften Beziehungen zu den russischen Oligarchen,
            sie brachten die Gesetze der Marktwirtschaft in die ehemaligen
            Republiken der Sowjetunion. Wie das ging, beschreiben Javier Blas
            und Jack Farchy in ihrem Buch «The World for Sale»: «Inmitten des
            Chaos wurden die Händler zu wichtigen Lebensadern für angeschlagene
            Fabriken und stützten sogar ganze Regierungen.»
          </p>
          <p>
            Das führte dazu, dass gemäss eines Berichts der Schweizer Botschaft
            in Moskau rund 80 Prozent der russischen Rohstoffe über die Schweiz
            verkauft werden, vor allem über Genf, Lugano, Zürich und Zug.
          </p>
          <p>
            Es sprach sich damals auch in Russland herum, dass man in Zug ein
            besonders günstiges steuerliches Umfeld vorfinde. Eine spezielle
            Holdingbesteuerung erlaubte es den Firmen seit den 1920er-Jahren,
            die Abgaben an den Staat zu optimieren.
          </p>
          <p>
            Hanspeter Uster kennt das, seufzend erzählt er, wie er ein
            Politikerleben lang gegen noch tiefere Steuern gekämpft hatte – und
            gegen noch mehr zwielichtige russische Rohstofffirmen. Der
            64-Jährige war von 1991 bis 2006 grün-alternativer Regierungsrat in
            Zug. Vor zwei Wochen lief er mit mehr als 100 Demonstrierenden durch
            die Stadt. Nord Stream, Metal Trade Overseas SA, Sber Trading Swiss
            AG und Gazprom: ein Marsch von einer russischen Rohstofffirma zur
            nächsten, alle mit mehr oder weniger direkten Verbindungen zu Putin.
          </p>
          <p>
            Uster hat vor solchen Firmen immer wieder gewarnt. 1995 zum Beispiel
            vor der Gefahr von Geldwäscherei und der Ostmafia. 2002 boykottierte
            der Zuger Regierungsrat wegen Usters Hinweis die Vergabe eines
            Friedenspreises an Wladimir Putin in Zug – mitten im
            Tschetschenien-Krieg. 2006 warnten Uster und seine Parteikollegen
            explizit vor Putin-nahen Firmen in seinem Kanton.
          </p>
          <p>
            Trotzdem blieb Zug mit Putin verbandelt. Kaum ein Beispiel zeigt
            dies besser als die Mutter aller Öldeals. Die staatliche
            Ölgesellschaft Rosneft fusionierte 2013 mit der wichtigen Ölfirma
            TNK-BP, um einen grossen Teil des russischen Ölgeschäfts unter einem
            Dach zu vereinen. Mit am Verhandlungstisch: Wladimir Putin.{' '}
          </p>
          <p>
            Der russische Oligarch Igor Sechin, ein enger Vertrauter Putins,
            brauchte für die Fusion Kapital im Umfang von 55 Milliarden Dollar.
            Er fand dieses einerseits mithilfe westlicher Banken, andererseits
            halfen ihm die Schweizer Rohstoffriesen Glencore mit Sitz in Zug und
            Vitol mit Sitz in Genf. Sie schossen 10 Milliarden Dollar ein und
            sicherten sich so Rechte am russischen Öl. Als es nach der
            Krim-Annektion zu Sanktionen gegen Rosneft kam, brauchte die Firma
            neues Kapital. Der damalige Glencore-Chef Ivan Glasenberg fädelte
            2016 eine Kapitalspritze über rund 11 Milliarden Dollar ein. Als
            Dank erhielt er von Putin den russischen Orden der Freundschaft, das
            russische Fernsehen sendete.
          </p>
          <p>
            Es ist wohl das, was Uster meint, wenn er klagt und sagt: «Wir
            finanzieren diesen Krieg indirekt mit.»
          </p>
          <p className='author'>Christian Zürcher, Jorgos Brouzos</p>
          {/* <h5>Titel 1</h5> */}
          {/* <Image
            // file={require('../../images/alma/tatort-hausen.jpg')}
            aspectRatio={browserCheck.isMobile ? '4:3' : '16:9'}
            className='imageChapter'
            source='Bildlegende'
          /> */}
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/visa.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 2',
      title: 'Golden Visa',
      lead: 'Wie das Geschäft mit dem Permis B funktioniert'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/visa.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Den Schlüssel zur komfortablen und sicheren Schweiz finden russische
            Oligarchen gut versteckt im eidgenössischen Ausländer- und
            Integrationsgesetz: in einem Gummiparagrafen, bei dem drei Wörter
            vieles ermöglichen.
          </p>
          <p>
            Die Sonderklausel im Artikel 30 erlaubt es den Kantonen,
            Aufenthaltsbewilligungen an Ausländerinnen und Ausländer zu
            erteilen, wenn «wichtige öffentliche Interes­sen» dies erfordern.
            Auf diese Weise können auch Personen in die Schweiz ziehen, die
            sonst kaum eine Chance auf einen Aufenthaltstitel hätten – weil sie
            weder EU-Bürger noch Fachkräfte noch politische Flüchtlinge sind.
            Bedingung ist nur, dass sie reich sind.
          </p>
          <p>
            Denn die «wichtigen öffentlichen Interessen», auf die sich die
            Kantone in solchen Fällen berufen, sind meistens Geld. Das heisst:
            Wer dem Kanton genügend hohe Steuereinnahmen verspricht, bekommt das
            Permis B. Es handelt sich um die Schweizer Version eines «Golden
            Visa», einer gekauften Aufenthaltsbewilligung.
          </p>
          <p>
            Total 368 Personen leben laut dem Staatssekretariat für Migration
            derzeit gestützt auf diese Klausel in der Schweiz. Darunter bilden
            85 Russinnen und Russen die mit Abstand grösste Gruppe – vor den
            Chinesen (37, den Amerikanern (22) und den Saudis (16).
          </p>
          <p>
            Nur ein Teil der Kantone macht mit bei diesem Spiel. Drei Viertel
            der 85 Russinnen und Russen konzentrieren sich auf fünf Kantone:
            Genf (24), Tessin (14), Waadt (11), Obwalden (8) und Zug (8).
          </p>
          <p>
            Wer diese Personen sind, geben die Bundes- und Kantonsbehörden nicht
            bekannt. Nur Einzelfälle sind publik. So liess sich 2014 der
            einstmals reichste Russe, der einstige Oligarch und spätere
            Putin-Kritiker Michail Chodorkowski, nach seiner Entlassung aus
            einem russischen Gefängnis in Rapperswil-Jona SG nieder. Gut ein
            Jahr später zog Chodorkowski mit seiner Familie nach London weiter.
          </p>
          <p>
            2016 wollte <Link href='740582868822'>Roman Abramowitsch,</Link> der
            heute sanktionierte langjährige Besitzer des FC Chelsea, nach
            Verbier VS ziehen. Die Walliser Behörden waren gewillt, ihm die
            Aufenthaltsbewilligung zu erteilen, doch das Bundesamt für Polizei
            (Fedpol) und das Staatssekretariat für Migration (SEM) legten ihr
            Veto ein, weil der Oligarch ein Sicherheits- und Reputationsrisiko
            für die Schweiz sei. Abramowitsch hat dies stets bestritten.
          </p>
          <p>
            Wer gestützt auf Artikel 30 in die Schweiz zieht, schliesst mit dem
            entsprechenden Kanton meist ein Pauschalsteuerabkommen ab. Das
            bedeutet: Er oder sie muss nicht das ganze Vermögen und Einkommen
            versteuern. Als Bemessungsgrundlage für das Steueramt dienen nur die
            Lebenshaltungskosten.
          </p>
          <p>
            Seit Beginn der russischen Invasion in die Ukraine hat die EU 874
            natürliche Personen und 62 Unternehmen und Organisationen
            sanktioniert. Die Schweiz hat diese Massnahmen vollständig
            übernommen. Das wirft die Frage auf: Wie viele von ihnen leben hier?
          </p>
          <p>
            Das wollte am Montag SP-Nationalrätin Samira Marti in der
            Fragestunde des Nationalrats wissen. Die Antwort der zuständigen
            Justizministerin Karin Keller-Sutter (FDP) war kurz: Von den 85
            russischen Staatsangehörigen, die gestützt auf Artikel 30 in der
            Schweiz lebten, befinde sich niemand auf der Sanktionsliste.
          </p>
          <p>
            Doch Keller-Sutters Aussage ist inzwischen Makulatur, wie Recherchen
            dieser Zeitung zeigen. Denn am Mittwoch hat die Schweiz weitere
            Sanktionspakete der EU übernommen. Unter den neu Sanktionierten
            finden sich vier Russen, die in der Schweiz aufenthaltsberechtigt
            sind und mit Rohstoffen geschäften.
          </p>
          <p>
            Es handelt sich um das Ehepaar Dmitri und Galina Pumpianski, das
            sich in Genf niedergelassen hat, und um Andrei Melnitschenko mit
            Engadiner Wohnsitz. Sohn Alexander Pumpianski, der sogar den
            Schweizer Pass besitzt, ist ebenfalls sanktioniert.{' '}
            <Link href='985275033828'>
              Nicht in der Schweiz hält sich Wladimir Putins angebliche Geliebte
              auf
            </Link>
            .
          </p>
          <p>
            In den vier Fällen gibt es nun ein Zielkonflikt: Die Sanktionen
            umfassen auch Einreiseverbote, während eine Aufenthaltserlaubnis -
            wie der Name sagt - den Aufenthalt in der Schweiz erlaubt.
          </p>
          <p className='author'>Thomas Knellwolf, Markus Häfliger</p>
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/health.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 3',
      title: 'Patiententourismus',
      lead: 'Wo sie sich gesund pflegen lassen'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/health.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Er fliegt mit dem Privatjet nach Zürich und fährt mit der Limousine
            ins Spital. Der Russe ist reich, der Bruder eines noch reicheren
            Oligarchen, und er hat ein Problem: Darmkrebs. Darum reist er samt
            Familie in die Schweiz zu Dr. med. Hani Oweira, Viszeralchirurg,
            Spezialist für Bauchoperationen, über die Landesgrenzen hinaus
            bekannt.
          </p>
          <p>
            Fünf Stunden dauert die Operation, dann ist der Tumor entfernt. Der
            Russe bedankt sich bei Oweira – und fliegt wieder in die Heimat. Das
            ist Gesundheitstourismus. Ein ausländischer Patient reist für die
            Behandlung in die Schweiz, nimmt Familienmitglieder mit, lässt diese
            an guten Adressen übernachten und geht wieder nach Hause, gesund und
            erholt. Ein transformatives Ferienerlebnis. Ein gutes Geschäft.
          </p>
          <p>
            Schweiz Tourismus hat sich darum bereits vor Jahren auf die
            Zielgruppe Russland konzentriert und arbeitet mit{' '}
            <Link href='https://www.myswitzerland.com/en-ch/planning/about-switzerland/health/medical-facilities-search/'>
              30 Kliniken und Spitälern
            </Link>{' '}
            zusammen. Von Genf über Meiringen bis nach Sorengo und Cazis. Viele
            Spitäler preisen auf ihrer Website ihre medizinischen Angebote auch
            auf Russisch an. Darüber hinaus wird unter anderem auf exklusive
            5-Stern-Hotels hingewiesen oder auf Russisch sprechende
            Patient-Relations-Managerinnen.
          </p>
          <p>
            2019 gab es in der Schweiz 350’000 Übernachtungen von russischen
            Gästen – mehrheitlich im Luxussegment. Wie viele Russen und
            Russinnen extra etwa für eine Tumoroperation, eine
            Schönheitsbehandlung oder eine Rehabilitation in die Schweiz reisen,
            wird jedoch nicht separat erfasst. Bei der Hirslanden-Gruppe machten
            sie 2014 bis 2016 die grösste Gruppe aus dem Ausland aus, bei den
            Universitätsspitälern dagegen sind sie Einzelfälle.
          </p>
          <p>
            «Wenn wir jetzt Anfragen bekommen, überprüfen wir zuerst, ob die
            Personen auf der Sanktionsliste sind oder sich irgendwie politisch
            exponiert haben», sagt Sascha Nicol, Head of Customer Care bei
            Hirslanden. Des Weiteren meldeten sich weniger Menschen aus Russland
            für Behandlungen, da durch den Ausschluss russischer Finanzinstitute
            aus dem internationalen Bankennetzwerk Swift Zahlungen nicht mehr
            möglich seien.
          </p>
          <p>
            Und dann ist da noch Corona. Die Operation des eingangs erwähnten
            Russen fand 2019 statt. «Seither ist die Zahl der russischen
            Patienten stark gesunken», sagt Doktor Hani Oweira. Das wird sich
            wohl nicht sehr bald ändern.
          </p>
          <p className='author'>Barbara Reye, Christian Zürcher</p>
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/bank.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 4',
      title: 'Banken',
      lead: 'Wo das Geld liegt'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/bank.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            «Die Schweiz ist die erste Wahl für korrupte Russen.» Das sagte der
            derzeit inhaftierte russische Oppositionspolitiker Alexei Nawalny
            2016 in einem Interview mit Swissinfo.ch. Die Aussage ist nicht zu
            überprüfen. Klar ist jedenfalls, dass Schweizer Banken für Russen
            mit viel Geld seit Jahren attraktiv sind. Laut einer Umfrage von
            Ernst & Young bei Finanzspezialisten von 2020 sind sie sogar am
            beliebtesten weltweit.
          </p>
          <p>
            Gemäss der Bank für Internationalen Zahlungsausgleich liegen aktuell
            rund 11 Milliarden Dollar von russischen Privatpersonen und
            Unternehmen auf Schweizer Bankkonten. Das sind 30 Prozent der
            erfassten russischen Guthaben auf Konten auf der ganzen Welt. Diese
            Zahl beinhaltet aber nur die Gelder von Personen und Firmen mit Sitz
            in Russland. Die meisten Superreichen sind längst anderswo ansässig.
            Deshalb ist eher der Anteil als der absolute Wert aussagekräftig:
            Fast jeder dritte Dollar, den Bürger und Firmen mit Sitz in Russland
            ins Ausland brachten, gelangte in die Schweiz.
          </p>
          <p>
            Wie viel russisches Geld insgesamt auf Schweizer Banken liegt, dazu
            gibt es lediglich Schätzungen. Die aktuellste stammt vom obersten
            Bankenvertreter, Marcel Rohner, Präsident der Schweizerischen
            Bankiervereinigung. Er bezifferte diese Woche die Höhe der
            russischen Vermögen in der Schweiz auf 150 bis 200 Milliarden
            Dollar. Das sind rund 4 bis 5,5 Prozent der gesamten auf Schweizer
            Banken verwalteten ausländischen Vermögen.
          </p>
          <p>
            Wie viele russische Millionen oder Milliarden in der Schweiz
            problematisch sind, ist derzeit ebenfalls nicht eindeutig zu klären.
            Schweizer Banken müssen Vermögen von sanktionierten Russen sperren
            und dem Staatssekretariat für Wirtschaft (Seco) melden. Auch alle
            übrigen russischen Vermögen über 100’000 Franken müssen sie melden.
            Bis heute ist das Seco aber nicht in der Lage, einen ersten
            Zwischenstand zu geben. Bekannt ist, dass einzelne nun sanktionierte
            Oligarchen zumindest bis vor einigen Jahren grosse Summen bei
            Schweizer Banken hatten. So zum Beispiel Alischer Usmanow mit
            mehreren Hundert Millionen bei der Credit Suisse.
          </p>
          <p>
            Klar ist auch, dass die Schweizer Justiz in den vergangenen Jahren
            wiederholt versucht hat, mutmasslich kriminelle Gelder aus Russland
            zu verfolgen. Jedoch scheiterten Verfahren daran, dass Russland
            keine Rechtshilfe leistete. So etwa im jüngst eingestellten
            Verfahren um Millionen aus einem der prominentesten
            Wirtschaftsverbrechen in Russland, dem sogenannten Fall Magnitski.
            Oder auch in einem Fall, in dem rund 50 Millionen zweifelhafter
            Herkunft für den Bau eines Palasts für Präsident Putin über eine
            Schweizer Bank flossen. Auch der Putin-Freund Sergei Roldugin
            kontrollierte in Zürich ein Konto, über das Dutzende Millionen
            flossen. Das zeigten 2016 Dokumente aus den Panama Papers. Laut den
            Sanktionslisten des Seco ist er der «Verwalter von Wladimir Putins
            Vermögen».
          </p>
          <p className='author'>Christian Brönnimann, Oliver Zihlmann</p>
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/chalet.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 5',
      title: 'Immobilien',
      lead: 'Wo sie Villen und Chalets kaufen'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/chalet.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Meterhohe Hecken, davor ein Sicherheitsdienst - in Cologny GE ist
            das Teil des Ortsbilds. Das Dorf auf der Südseite des Genfersees
            gehört zu den teuersten Adressen der Welt. Ein Quadratmeter kostet
            bis zu 35’000 Franken. Könige und Staatsoberhäupter aus Ländern mit
            zweifelhaftem Ruf haben in der Genfer Gemeinde ihre Residenzen. Dazu
            kommen sehr reiche Menschen. Zum Beispiel Gennadi Timtschenko. Als
            einer der grössten Erdölhändler der Welt hat er ein riesiges
            Vermögen angehäuft. Die Spekulationen beginnen bei zwölf Milliarden
            Franken.
          </p>
          <p>
            18 Millionen zahlte Timtschenko 2002 für das mehrere Hektaren grosse
            Anwesen (inklusive Indoor-Tennisplatz) in Cologny. Die Nähe zum
            Genfer Finanz- und Handelsplatz hat ihn, wie so viele andere Russen
            auch, an den Genfersee gelockt.
          </p>
          <p>
            Der 69-Jährige ist schon seit der Krim-Annektion 2014 auf einer
            Sanktionsliste der USA. Durch die Nähe zu Putin ist der
            Multimilliardär nun auch auf jener der EU gelandet. Entscheidender
            Unterschied: Nur letztere wird von der Schweiz mitgetragen.
          </p>
          <p>
            Unsichere Zeiten sind es auch für Andrei Melnitschenko. Der
            milliardenschwere Unternehmer, der in St. Moritz ein 5002
            Quadratmeter grosses Anwesen samt Spa-Bereich bewohnt, ist seit
            Mittwoch auf der Sanktionsliste der Schweiz. Am 24. Februar war der
            Chef des Düngemittelriesen Eurochem Teil eines exklusiven Treffens
            der Wirtschaftselite mit Putin. Gegenüber dem deutschen Magazin
            «Stern» liess Andrei Melnitschenko verlauten, dass er als
            Vorstandsmitglied und nicht geschäftsführender Direktor der in Zug
            gemeldeten Unternehmen zurückgetreten sei. Die «unbegründeten und
            ungerechtfertigten» Sanktionen werde er anfechten.
          </p>
          <p>
            Andrei Melnitschenko war mit seiner Firma in der Schweiz, als der
            Ukraine-Konflikt schwelte. Die neutrale Schweiz beteiligte sich
            damals nicht direkt an den Sanktionen und bot einen sicheren Boden
            für seine globalen Geschäfte. Nach einigen Jahren der Ruhe wird es
            nun für Leute wie Melnitschenko auch im Schweizer Idyll ungemütlich.
          </p>
          <p>
            Das gilt selbst für jene russischen Oligarchen in der Schweiz, die
            bis heute nicht auf der Sanktionsliste auftauchen, weder auf jener
            der EU noch jener der Schweiz. Dazu gehören einflussreiche
            Unternehmer wie Viktor Vekselberg mit einer Wohnung in Zug oder auch
            Dmitri Rybolowlew. Letzterer besitzt in Gstaad zwei Chalets, einst
            gekauft für über 103 Millionen Franken.
          </p>
          <p className='author'>
            Yann Cherix, Sylvain Besson, Quentin Schlapbach
          </p>
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/internat.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 6',
      title: 'Internate',
      lead: 'Warum die Sprösslinge hier zur Schule gehen'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/internat.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Erst am Schluss erfuhr Deutschlehrer Ulrich Schweizer, wer diese
            Anastasia Molokanowa in seiner Klasse wirklich war. An ihrem letzten
            Schultag Ende 2009 nannte ihm die Russin ihren wahren Namen.
            Molokanowa sei der Name ihrer Mutter. Eigentlich heisse sie
            Chodorkovskaya, ihr Vater sei der einstige Oligarch Michail
            Chodorkowski. «Ich war nicht sonderlich überrascht, ich kenne ja die
            Schule und ihre Geschichte», sagt Schweizer, der von 2007 bis 2010
            am Lyceum Alpinum in Zuoz unterrichtete. Er selbst ging im
            Eliteinternat zur Schule, einer seiner Klassenkameraden damals:
            Rolf, der Sohn von Gunter Sachs.
          </p>
          <p>
            Anastasia Chodorkovskaya war eines von vielen russischen Kindern an
            Schweizer Eliteinternaten. Das erklärt auch, weshalb viele reiche
            Russen einen engen Bezug zur Schweiz haben. Der russische
            Immobilienmakler Sergei Sander erzählte einmal, dass es drei Gründe
            gebe, weshalb die Schweiz so populär sei bei seinen Landsleuten:
            «Sicherheit, Geld und Bildung.»
          </p>
          <p>
            Und diese Bildung lassen sie sich etwas kosten. In Zuoz kostet ein
            Schuljahr mit Einzelzimmer rund 95’000 Franken. Im Eliteinternat Le
            Rosey in Rolle VD sind es 132’000 Franken, im St. Galler Internat
            Rosenberg rund 140’000 Franken. Darin inbegriffen: höchste
            Diskretion.
          </p>
          <p>
            Trotz der Preise könnten die Schulen sogar noch deutlich mehr
            russische Kinder aufnehmen. Als sie in den 90er-Jahren von ihnen
            fast überrannt wurden, führten viele eine Quotenregel ein: Im Zuger
            Institut Montana darf jede Nationalität nur noch mit einem Anteil
            von zehn Prozent vertreten sein, in Le Rosey ebenso.
          </p>
          <p>
            Im Institut Rosenberg in St. Gallen gibt es keine fixen Quoten, und
            doch achtet man auf die Zusammensetzung. 16 der 210 Schülerinnen und
            Schüler kommen aus Russland, 7 aus der Ukraine. Bernhard O. A.
            Gademann führt das Institut in der vierten Generation. Er war bei
            Kriegsausbruch selbst gespannt, wie die Kinder aus den beiden
            Ländern miteinander umgehen. Er war bald beruhigt. «Sie sehen sich
            nach wie vor als Freunde und nicht als Repräsentanten einer Nation.
            Wir erleben Solidarität statt Polarisierung.»
          </p>
          <p>
            Gademann sieht primär zwei Gründe, weshalb russische Eltern ihre
            Kinder gerne in die Schweiz zur Schule schicken. Wegen der hohen
            Bildungsqualität. Und wegen der Marke Schweiz, die ziehe noch immer
            sehr.
          </p>
          <p>
            Einen weiteren Grund weiss Ulrich Schweizer, der einstige Lehrer in
            Zuoz: das Schaffen von Netzwerken. «Sie können später im Berufsleben
            hilfreich sein.» Ihm ist von seiner russischen Schülerschaft vor
            allem eines geblieben: Die Mädchen waren ehrgeizig und lernwillig,
            viele Jungen hingegen «unendlich faul».
          </p>
          <p className='author'>Christian Zürcher</p>
        </>
      )
    }
  },
  {
    card: {
      Image: (
        <>
          <img
            src={require('../../images/kunst.jpg')}
            className='ui fluid image portraitImageFront'
            style={{ margin: '0 auto' }}
          />
        </>
      ),
      chapter: 'Kapitel 7',
      title: 'Kultur',
      lead:
        'Wie der Schweizer Kunstmarkt funktioniert und was die Stiftungen unterstützen'
    },
    overlay: {
      headerImage: (
        <>
          <Image
            file={require('../../images/kunst.jpg')}
            className='headerIcon'
          />
        </>
      ),
      main: (
        <>
          <p>
            Ausgerechnet ein verärgerter russischer Oligarch verhalf der
            Öffentlichkeit zu einem Einblick in den verschwiegenen Schweizer
            Kunstmarkt. Es war der in Monaco und Gstaad lebende Rohstoffhändler
            Dmitri Rybolowlew, der 2015 gegen den Genfer «König der
            Zollfreilager», Yves Bouvier, klagte.
          </p>
          <p>
            Bouvier wusste als Betreiber einer im Genfer Zollfreilager
            ansässigen Lagerfirma von Kunstwerken, die Rybolowlew
            interessierten. Der Schweizer kaufte sie - und verkaufte sie an
            Rybolowlew mit einem laut dem Russen «unrechtmässig» hohen Gewinn
            weiter.
          </p>
          <p>
            Was der Fall auch zeigte: Die meisten Transaktionen finden in Genf
            als sogenannte Private Sales statt. Nicht öffentliche Verkäufe also.
            Es ist anzunehmen, dass viele der Werke vor und nach dem Kauf in den
            gut klimatisierten Räumen des Port Franc verbleiben. Die «New York
            Times» schätzte 2016, dass sich im Genfer Zollfreilager gegen 1000
            Werke allein von Picasso befinden.
          </p>
          <p>
            Im Nachgang der Affäre Rybolowlew und nach den Enthüllungen der
            Panama Papers wurden zwar strengere Kontrollregeln für die Schweizer
            Freilager eingeführt (seit 2009: Inventarpflicht mit den Namen der
            Eigentümer und die Erlaubnis von Zollinspektionen; seit 2016:
            Unterstellung der Freilager unter das Geldwäschereigesetz). Das
            ändert aber wenig an der Attraktivität der Schweiz als ein sicheres
            Land, wo man Kunst kaufen, verkaufen und diskret lagern kann.
          </p>
          <p>
            Im anlässlich der Art Basel im September 2021 veröffentlichten
            Kunstmarkt-Report der UBS figuriert die Schweiz als einer der fünf
            weltweit wichtigsten Kunstmärkte, neben den USA, Grossbritannien,
            Hongkong und Deutschland. Die Summe des von reichen Sammlern
            jährlich für Kunst ausgegebenen Geldes hat sich seit 2019
            verdreifacht - der Anteil der Russen lässt sich aber nicht
            beziffern. Es ist anzunehmen, dass viele der von den Oligarchen in
            der Schweiz erworbenen Kunstwerke auch in der Schweiz bleiben. In
            diversen Zollfreilagern, in Villen im Tessin, in Gstaad, St. Moritz,
            an der Zürcher Goldküste oder am Genfersee.
          </p>
          <p>
            Neben dem Kauf von Kunst unterstützen viele Russinnen und Russen
            seit Jahren den Schweizer Kulturbetrieb. Das provoziert in diesen
            Tagen unangenehme Fragen. Das Klassikfestival in Verbier will
            mehrere 100’000 Franken zurückzahlen, die es von der Neva Foundation
            erhalten hat. Dieser Genfer Stiftung steht Elena Timtschenkos vor,
            Gattin des auf der Schweizer Sanktionsliste stehenden Gennadi. Und
            die Stiftung des Putin-Vertrauten Suleiman Kerimow (seit 16. März
            auf der Schweizer Liste) hat bis zu ihrer kürzlich erfolgten
            Auflösung am 28. Februar über Jahre mehr als 400 Millionen Franken
            an diverse Schweizer Kulturanlässe verteilt, unter ihnen ans Zürcher
            Filmfestival, ans Luzerner Blue Balls Festival und ans
            Comic-Festival Fumetto.
          </p>
          <p>
            Auch das Olympische Museum in Lausanne musste jüngst Stellung
            beziehen. Es hatte von Alischer Usmanow einst das rund neun
            Millionen Dollar teure Original des Olympischen Manifests von 1892
            geschenkt bekommen. Nun ist Usmanow aber ebenfalls auf der
            Sanktionsliste und das Lausanner Museum nun im Besitz eines
            toxischen Geschenks. Doch zurückgeben will dieses das teure Präsent
            offenbar nicht. Vorerst.
          </p>
          <p className='author'>Text: Ewa Hess, Yann Cherix</p>
        </>
      )
    }
  }
]
